export function calcRemaining(allotment, spentAllotment) {
  return parseFloat(allotment, 10) - parseFloat(spentAllotment, 10);
}
